import { Controller } from "@hotwired/stimulus"

// Removes its element on demand, plus related elements named by id that live
// elsewhere in the DOM (e.g. a hidden form field kept outside the removed card).
export default class extends Controller {
  static values = { linkedIds: Array }

  remove() {
    this.linkedIdsValue.forEach((id) => document.getElementById(id)?.remove())
    this.element.remove()
  }
}
